import { DsChartData } from './chart-data.class';

/**
 * Data for a time chart ( original label like follows 'MM-YYYY')
 */
export class DsMonthlyTimeChartData extends DsChartData {
  /**
   * Creates an instance of DsMonthlyTimeChartData.
   *
   * @param jsonData the json data
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(jsonData: any = {}) {
    super(jsonData);
    if (jsonData.label) {
      const splitDate = jsonData.label.split('-');
      this.label = new Date(parseInt(splitDate[1], 10), parseInt(splitDate[0], 10) - 1);
    }
  }
}
